<template>
  <div id="gallery" class="site">
    <div
      v-for="(gallery, index) in activeGallery"
      class="gallery-content"
      :key="index"
    >
      <h1>{{ gallery.title }}</h1>
      <div class="gallery-wrapper">
        <img
          :src="require(`@/assets/img/gallery/${gallery.title}/${img}.jpg`)"
          v-for="(img, index) in gallery.images"
          :key="index"
          v-scroll-reveal
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  title: "Galerie - Ocular",
  computed: {
    projects() {
      return this.$store.state.galleries;
    },
    activeGallery: function () {
      return this.$store.state.galleries.filter((gallery) => {
        return gallery.title.match(this.$route.params.galleryName);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#gallery {
  .gallery-content {
    .gallery-wrapper {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(33rem, 1fr));
      grid-gap: 3vw;
      img {
        width: 100%;
      }
    }
  }
}
</style>
